var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { injectable } from '../../../Data/Decorators/Injectable';
import { inject } from '../../../Data/Decorators/Inject';
import { ICoreEventsRepositoryType } from '../../UseCases/Events/ICoreEventsRepository';
import { ISetSIDTokenUseCaseType } from '../../UseCases/Auth/SetSIDTokenUseCase/ISetSIDTokenUseCase';
import { IPayloadRepositoryType } from '../../UseCases/Payload/IPayloadRepository';
import { IApplicationRepositoryType } from '../../UseCases/Application/IApplicationRepository';
let CoreEventsService = class CoreEventsService {
    constructor(eventsRepository, payloadRepository, appRepository, setSid) {
        this.eventsRepository = eventsRepository;
        this.payloadRepository = payloadRepository;
        this.appRepository = appRepository;
        this.setSid = setSid;
        this.exception_sub = this.appRepository.addOnLogExceptionErrorHandler(exceptions => {
            this.appRepository.addExceptions(exceptions);
        });
    }
    init() {
        return Promise.resolve()
            .then(() => {
            this.eventsRepository.getDidUpdateSid().observe(this, event => {
                if (!this.is_initialized || typeof event.data.sid !== 'string') {
                    return;
                }
                this.setSid.execute(event.data.sid);
            });
            this.eventsRepository.getUpdatePayloadEvent().observe(this, event => {
                const data = Object.assign(Object.assign({}, this.payloadRepository.getPayload(event.module).value), event.data);
                this.payloadRepository.updatePayload(event.module, data);
            });
            if (this.appRepository.isNetworkUnavailable()) {
                return;
            }
            this.appRepository.getExceptions()
                .then(exceptions => {
                if (exceptions.length <= 0) {
                    return;
                }
                this.appRepository.logExceptions(exceptions).then(isOK => {
                    if (!isOK) {
                        return undefined;
                    }
                    return this.appRepository.clearExceptions();
                });
            });
        })
            .then(() => {
            this.is_initialized = true;
        });
    }
    onDestroy() {
        var _a;
        (_a = this.exception_sub) === null || _a === void 0 ? void 0 : _a.call(this);
    }
};
CoreEventsService = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(ICoreEventsRepositoryType)),
    __param(1, inject(IPayloadRepositoryType)),
    __param(2, inject(IApplicationRepositoryType)),
    __param(3, inject(ISetSIDTokenUseCaseType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], CoreEventsService);
export { CoreEventsService };
